import React from 'react';
import welcomeImage from '../assets/welcome-woman.png';
import doorImage from '../assets/door-image.png';
import ratingImage from '../assets/rating-app-illustration.png';
import IconUI from "../assets/Iicon-user-interface.png";
import IconFeedback from "../assets/icon-anonymous-feedback.png";
import IconCriteria from "../assets/icon-modifiable-criteria.png";
import IconPerformance from "../assets/icon-performance.png";
import IconShift from "../assets/icon-paradigm-shift.png";
import IconData from "../assets/icon-transparent-data.png";
import IconGrowth from "../assets/icon-growth.png";
import IconEmpowerment from "../assets/icon-empowerment.png";
import IconTeam from "../assets/icon-thriving-team.png";
import cornerPattern from "../assets/cornerPattern.jpg";
import checkIcon from "../assets/bcheckIcon.svg";
import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";

const benefits = [
  "In-depth reviews can be left by users to help others learn from their experiences.",
  "The app rates goods and services in a flash using a star system.",
  "For the most recent information, ratings and reviews are updated in real time.",
  "In-depth reviews can be left by users to help others learn from their experiences.",
  "The app rates goods and services in a flash using a star system.",
  "For the most recent information, ratings and reviews are updated in real time.",
];

const features = [
  {
    icon: IconShift,
    title: "Paradigm shift",
    description:
      "Feedback now delivers real-time, data-driven insights that drive continuous improvement and boost agility.",
    bg: "bg-[#DFFCF2]",
  },
  {
    icon: IconData,
    title: "Transparent & Data-driven",
    description:
      "Transparent, data-driven feedback promotes accountability and continuous improvement through objective decision-making.",
    bg: "bg-[#F3F2FF]",
  },
  {
    icon: IconGrowth,
    title: "Driving constant growth",
    description:
      "Continuous improvement fuels growth by refining processes and products through customer feedback.",
    bg: "bg-[#E7FEE1]",
  },
  {
    icon: IconEmpowerment,
    title: "Empowerment of workforce",
    description:
      "Employee empowerment provides workers with the resources and support to make decisions that benefit both the organization and themselves.",
    bg: "bg-[#FFF8DC]",
  },
  {
    icon: IconTeam,
    title: "Building a thriving team",
    description:
      "A collaborative, dynamic workplace respects diverse views and fosters cooperation and creativity, driving both success and employee happiness.",
    bg: "bg-[#F8F8F8]",
  },
];

const featuress = [
  {
    title: "User-Friendly Interface",
    description:
      "The app’s intuitive interface ensures easy use and broad participation, allowing employees to quickly rate peers based on their observations.",
    icon: IconUI,
    bg: "bg-[#D7F3FB]",
  },
  {
    title: "Anonymous Feedback",
    description:
      "The Rating App ensures anonymity, encouraging honest feedback and fostering a culture of transparency and trust without fear of consequences.",
    icon: IconFeedback,
    bg: "bg-[#EDE4FF]",
  },
  {
    title: "Modifiable evaluation criteria",
    description:
      "Businesses can customize evaluation criteria to align with their goals, as the Rating Application adapts to prioritize what matters most.",
    icon: IconCriteria,
    bg: "bg-[#FEF3C7]",
  },
  {
    title: "From potential to performance",
    description:
      "Top performers are recognized for their achievements, while all employees use peer feedback to identify growth areas.",
    icon: IconPerformance,
    bg: "bg-[#FEE2E2]",
  },
];

const HospitalitySection = () => {

  // const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        // setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <Helmet>
        <title>Next-Level Hospitality Solutions | Employee Feedback & Rating App</title>
        <meta name="description" content="Enhance hospitality operations with LENTERA’s innovative Rating App. Capture anonymous employee feedback, improve teamwork, boost performance and drive continuous growth with real-time, data-driven insights." />
        <meta name="keywords" content="LENTERA hospitality solutions, continuous improvement in hospitality, team performance optimization." />
      </Helmet>

      <section className="w-full bg-[#e8d9ff] py-20 px-4 sm:px-6">
        <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">

          {/* Left Column – 60% with animation */}
          <motion.div
            className="w-full lg:w-[60%]"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h5 className="uppercase text-sm font-medium text-black mb-2">
              Hospitality
            </h5>

            <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
              Welcome to Next-Level<br />hospitality
            </h2>

            <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
              Step into a world where comfort meets sophistication and every detail is crafted with you in mind.
              Our approach to hospitality goes beyond expectations.
            </p>
          </motion.div>

          {/* Right Column – 40% with animation */}
          <motion.div
            className="w-full lg:w-[40%] flex justify-center"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >
            <img src={welcomeImage} alt="Welcome" className="w-[400px] h-auto" />
          </motion.div>
        </div>
      </section>

      <section className="bg-[#121212] py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-12">

          {/* Left Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="md:w-1/2 flex justify-center md:justify-start"
          >
            <div className="bg-white rounded-2xl p-4">
              <img
                src={doorImage}
                alt="Overview"
                className="rounded-xl w-[400px] h-auto"
              />
            </div>
          </motion.div>

          {/* Right Text Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            viewport={{ once: true }}
            className="md:w-1/2 text-white"
          >
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className="text-2xl font-semibold mb-4"
            >
              Overview
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
              className="text-lg mb-6 text-gray-300"
            >
              Employee input plays a critical role in creating a productive and healthy work
              environment in today‘s fast-paced corporate world.
            </motion.p>

            <motion.hr
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              viewport={{ once: true }}
              className="border-gray-50 mb-6 w-32 origin-left"
            />

            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              viewport={{ once: true }}
              className="text-2xl font-semibold mb-4"
            >
              Our impact on hospitality industries
            </motion.h3>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              viewport={{ once: true }}
              className="text-lg text-gray-300"
            >
              Traditional feedback methods often miss the mark.{" "}
              <span className="font-semibold text-white">LENTERA’s Rating App</span> transforms
              how businesses capture and use employee input.
            </motion.p>
          </motion.div>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-12">

          {/* Left Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <span className="inline-block bg-green-100 text-green-600 font-semibold text-sm px-4 py-1 rounded-full mb-4">
              OUR RATING APP
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Where feedback meets innovation
            </h2>
            <p className="text-lg text-gray-700">
              Lentera’s Rating App lets staff anonymously rate colleagues across predefined categories
              like problem-solving, leadership and communication. This structured feedback helps businesses
              identify strengths and pinpoint areas for improvement with clarity.
            </p>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
            className="md:w-1/2 flex justify-center"
          >
            <div className="rounded-full bg-yellow-50 p-4">
              <img
                src={ratingImage}
                alt="Rating App Illustration"
                className="w-[400px] h-auto rounded-full"
              />
            </div>
          </motion.div>
        </div>
      </section>

      <section className="w-full bg-[#141416] px-6 py-20 font-[Poppins] text-white">
        <div className="max-w-[1240px] mx-auto">
          {/* Header */}
          <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-6 mb-12">
            <h2 className="text-[40px] sm:text-[48px] font-bold leading-tight max-w-[500px]">
              Your benefits <br className="hidden md:block" /> with us
            </h2>
            <p className="text-[16px] leading-[28px] text-[#E1E1E1] max-w-[520px]">
              Experience hands-on learning, industry-relevant skills and dedicated
              support that empower you to thrive in the real world.
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {benefits.map((text, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="relative w-full bg-[#64EDAA] text-[#0F0F0F] rounded-[16px] p-6 min-h-[100px] flex items-center overflow-visible"
              >
                {/* Background Pattern (slightly more visible) */}
                <img
                  src={cornerPattern}
                  alt="pattern"
                  className="absolute top-0 left-0 w-[72px] h-[72px] opacity-10 pointer-events-none"
                />

                {/* Yellow checkmark circle positioned properly */}
                <div className="absolute -top-4 -right-4 w-[40px] h-[40px] bg-[]  flex items-center justify-center z-20">
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-[35px] h-[35px] object-contain"
                  />
                </div>

                {/* Text content */}
                <p className="text-[16px] font-medium leading-snug z-10 relative">
                  {text}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-[#F8F8F8] py-[80px] font-[Poppins]">
        <div className="max-w-[1200px] mx-auto px-4 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-[40px] font-semibold text-[#111827] leading-[48px] mb-[12px]"
          >
            Enhancing the quality of healthcare
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-[18px] text-[#444444] leading-[30px] max-w-[720px] mx-auto mb-[60px]"
          >
            We empower healthcare providers with smart tools and services that enhance care quality and improve patient outcomes.
          </motion.p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-[32px]">
            {featuress.map((feature, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-[12px] shadow-md overflow-hidden text-left"
              >
                <div className={`${feature.bg} px-[24px] py-[20px] flex items-center gap-[16px]`}>
                  <img src={feature.icon} alt={feature.title} className="w-[40px] h-[40px]" />
                  <h3 className="text-[18px] font-semibold text-[#111827]">{feature.title}</h3>
                </div>
                <div className="px-[24px] pt-[16px] pb-[24px]">
                  <p className="text-[16px] leading-[26px] text-[#444444]">{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-[80px] font-[Poppins] bg-white">
        <div className="max-w-[1200px] mx-auto px-4 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-[40px] font-bold text-[#111827] leading-[48px] mb-[12px]"
          >
            Key features
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-[18px] text-[#444444] leading-[30px] mb-[60px]"
          >
            Discover the game-changing key features that set you apart!
          </motion.p>

          {/* Top 3 Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-[24px] mb-[24px]">
            {features.slice(0, 3).map((feature, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                viewport={{ once: true }}
                className={`${feature.bg} rounded-[24px] text-left px-[24px] py-[28px]`}
              >
                <img src={feature.icon} alt={feature.title} className="w-[48px] h-[48px] mb-[20px]" />
                <h3 className="text-[20px] font-semibold text-[#111827] leading-[28px] mb-[12px]">
                  {feature.title}
                </h3>
                <p className="text-[16px] text-[#444444] leading-[26px]">{feature.description}</p>
              </motion.div>
            ))}
          </div>

          {/* Remaining Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[24px]">
            {features.slice(3).map((feature, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                viewport={{ once: true }}
                className={`${feature.bg} rounded-[24px] text-left px-[24px] py-[28px]`}
              >
                <img src={feature.icon} alt={feature.title} className="w-[48px] h-[48px] mb-[20px]" />
                <h3 className="text-[20px] font-semibold text-[#111827] leading-[28px] mb-[12px]">
                  {feature.title}
                </h3>
                <p className="text-[16px] text-[#444444] leading-[26px]">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HospitalitySection;